"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = _interopRequireDefault(require("./utils"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var validator = function validator(values) {
  if (!values.equation) {
    return 'Equation is required';
  }
  if (values.variables.length < 1) {
    return 'Equation must contain at least one variable';
  }
  var unknownVariables = _utils["default"].unknownVariables(values.equation, values.variables);
  var missingVariables = _utils["default"].missingVariables(values.equation, values.variables);
  if (unknownVariables.length) {
    return 'Only selected variables can be used in Equation, check: ' + unknownVariables.join(', ');
  }
  if (missingVariables.length) {
    return 'Equation must contain all selected variables, check: ' + missingVariables.join(', ');
  }
  if (values.equation.match(/[^a-zA-Z0-9._+\-*/^()\s]/)) {
    return 'Equation must contain only variables, numeric values, parentheses, and operators: + - * / ^';
  }
  return null;
};
var _default = exports["default"] = validator;